<template>
  <main class="single-item single-document">
    <div class="main-content" ref="tifyInstance">
      <h1 v-if="null" v-html="item.title" />
      <div class="" id="tify"></div>
      <div class="content">
        <div class="misc-wrapper misc-wrapper-item-player">
          <div class="arrow-link-item-player">
            <router-link
              @click.native="getAnotherItem()"
              :to="
                this.item.nextprev.next.path + '/' + this.item.nextprev.next.id
              "
              class="arrow-link arrow-link-prev"
              title=""
              v-if="this.item.nextprev.next && !fs"
            >
              <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
                <path
                  class="arrow"
                  d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
                ></path>
                <path
                  class="arrow arrow2"
                  d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
                ></path>
              </svg>
            </router-link>
          </div>
          <div class="icon-links to-center icon-links-item-player">
            <a
              v-if="!loading"
              href="javascript:void(0)"
              title="Otwórz w pełym oknie"
              @click="fullSize()"
              ><i class="icon-exp"></i
            ></a>
            <a
              :href="'https://www.facebook.com/sharer/sharer.php?u=' + meta.url" target="_blank"
              ><i class="icon-fb"></i
            ></a>
            <a href="https://fizykoteka.fuw.edu.pl/strona/informacje-prawne">
              <i class="icon-info"></i>
            </a>
          </div>
          <div class="desc-wrapper" v-if="tags">
            <p class="tags">
              <span v-for="tag in tags" :key="tag.id"
                ><a :href="'/etykieta/' + tag.name">{{ tag.name }}</a></span
              >
            </p>
          </div>
          <div class="arrow-link-item-player">
            <router-link
              @click.native="getAnotherItem()"
              :to="
                this.item.nextprev.prev.path + '/' + this.item.nextprev.prev.id
              "
              class="arrow-link arrow-link-next"
              title=""
              v-if="this.item.nextprev.prev && !fs"
            >
              <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
                <path
                  class="arrow"
                  d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
                ></path>
                <path
                  class="arrow arrow2"
                  d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
                ></path>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
require("@/assets/css/tify_rebranded.css");
import { eventBus } from "@/main.js";

export default {
  name: "ItemPlayerContent",
  props: ["item", "meta", "tags", "slides", "collection", "fs"],
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      loading: true,
      rkey: Math.random(),
    };
  },
  methods: {
    runTify() {
      // clean URL

      let manifest_uri =
        this.$config.MANIFEST_PATH + this.item.id + "/manifest";

      window.tifyOptions = {
        container: "#tify",
        immediateRender: false,
        init: true,
        language: "pl",
        manifest: manifest_uri,
        title: null,
        stylesheet: null,
        // custom tify option
        custom_translations_uri: "/static/assets/tify/translations/pl.json",
      };
      if (window.Tify) {


        // reset Tify params
        window.Tify.params = {
          filters: {},
          pages: [],
          panX: null,
          panY: null,
          zoom: null,
          rotation: null,
          view: "info",
        };
        // contributor hack

      }



    },
    fullSize() {
      eventBus.$emit("fullSize");
    },
    getAnotherItem() {
      eventBus.$emit("getAnotherItem");
    },
  },
  created() {
    //console.log(this.item)
    //console.log([this.collection.items_count,this.slides.length])
    this.$on("okHead", function () {
      this.runTify();
      //window.Tify.init();
    });
    if (this.collection) {
      if (this.collection.items_count == this.slides.length) {
        this.loading = false;
      }
    }
  },
  mounted() {
    // ugly hack for Contributor
    setTimeout(function(){
      let elements = Array.from(document.querySelectorAll("#tify h4"));
      let n = elements.find(element => element.innerText === "Contributor");
      if (n) {
          n.innerText = "Współtwórca";  
      }
}, 1000);


  },
  watch: {
    slides: function () {
      if (this.collection.items_count == this.slides.length) {
        this.loading = false;
      }
    },
  },
  head: {
    script: [
      {
        type: "text/javascript",
        src: "/static/assets/tify/tify.js",
        async: true,
        body: true,
      },
    ],
  },
};
</script>

<style scoped>

.single-item .main-content .icon-links {
  display: flex;
}

.single-item .main-content .icon-links a {
  width: 33%;
}

.info-icon img {
  height: 50px;
  width: 50px;
}

#tify {
  height: 80vh;
  min-height: 800px;
  max-height: 1000px;
  width: 100%;
  position: relative;
}

h1 {
  text-transform: uppercase;
}

.tags span {
  font-size: 0.5em;
  display: inline-block;
  padding: 5px;
  background: #465165;
  margin: 5px;
  text-transform: uppercase;
}

.tags span a {
  color: #fff;
}

.tags span a:hover {
  color: #c63;
}

.misc-wrapper-item-player {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
}

.icon-links-item-player {
  justify-content: space-around;
}

.arrow-link-prev {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>

<style>
.tify-header_title {
  font-family: franklin-gothic-atf, sans-serif;
  line-height: 1.2;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
  color: #465165;
  display: unset;
  white-space: normal;
}

:root {
  --plyr-color-main: #c63;
}

.video-background {
  background: #fff !important;
}

@media (max-width: 1950px) {
  .tify-header_title {
    font-size: 2.375rem;
  }
}
</style>

<style>

.tify-scan_page-button.-next, .tify-scan_page-button.-previous {
  width: 5em;
}

.tify-scan_page-button i {
  font-size: 5em;
}

.tify-scan_page-button {
    background: hsla(0,0%,100%,.3);
    border: 0;
    -webkit-box-shadow: 0 0 .5px rgba(0,0,0,.08),0 .5px 3px rgba(0,0,0,.24);
    box-shadow: 0 0 .5px rgba(0,0,0,.08),0 .5px 3px rgba(0,0,0,.24);
    height: 90px !important; /* powiększone od 60 do 90 px */
    margin-top: -30px;
    padding: 0;
    position: absolute;
    text-shadow: none;
    top: 50%;
    width: 60px; /* powiększone od 30 do 60 px */
    z-index: 9;

  }

/* show cover when audio */
.is_audio .plyr__poster {
    opacity: 1 !important;
}

@media (max-width: 768px) {
    .misc-wrapper-item-player {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
      grid-template-areas:
      "tags tags"
      "icons icons"
      "left right";
    }
    .arrow-link-prev {
        grid-area: left;
    }
    .arrow-link-next {
        grid-area: right;
    }
    .desc-wrapper {
        grid-area: tags;
    }
    .icon-links-item-player {
        grid-area: icons;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ItemPlayer/ItemPlayerContent.vue